module.exports = __webpack_public_path__ + "img/gallery-8.3f2cd618.jpg";